module.exports=[
  {
    "id": "tableware",
    "title": "Tableware",
    "subtext": "Includes 6” disposable plates, cocktail napkins, and silverware.",
    "options": [
      {
        "name": "Up to 50 guests",
        "price": {
          "value": 19.0
        }
      },
      {
        "name": "51-100 guests",
        "price": {
          "value": 39.0
        }
      },
      {
        "name": "101+ guests",
        "price": {
          "value": 55.0
        }
      }
    ]
  },
  {
    "id": "drinks",
    "title": "Water and soft drinks",
    "subtext": "$4 each",
    "counters": [
      {
        "name": "Fiji water",
        "price": {
          "value": 4.0
        }
      },
      {
        "name": "Sparkling water",
        "price": {
          "value": 4.0
        }
      },
      {
        "name": "Coconut water",
        "price": {
          "value": 4.0
        }
      },
      {
        "name": "Soda can (assorted)",
        "price": {
          "value": 4.0
        }
      }
    ]
  },
  {
    "id": "coffee",
    "title": "Coffee",
    "subtext": "$69 for 20 servings",
    "counters": [
      {
        "name": "20 servings of coffee with condiments, cups and stirrers",
        "price": {
          "value": 69.0
        }
      }
    ]
  },
  {
    "id": "bartending",
    "title": "Bartending package",
    "description": "Includes 2 craft cocktails + wine & beer service. Drink options can be fully customized post booking, and you can work with the bartender on what's best for your group",
    "tiers": [
      {
        "name": "40-49 guests",
        "price": {
          "value": 65.0,
          "per_person": true
        }
      },
      {
        "name": "50-59 guests",
        "price": {
          "value": 55.0,
          "per_person": true
        }
      },
      {
        "name": "60+ guests",
        "price": {
          "value": 45.0,
          "per_person": true
        }
      }
    ]
  }
]
